import API from '../../../../commons/api/api';
import { PRICE_PAY } from '../../../../commons/constans/stepVideo';
import * as actionTypes from '../actions/type';

export const initialState = {
  isProcessing: false,
  type: '',
  steps: {
    step_1: {},
    step_2: {
      content: '',
      contentShow: '',
    },
    step_3: {},
    step_4: {
      payment_type: '1pay',
      use_point: 0,
      use_money: PRICE_PAY.ONE,
    },
  },
};

const videoReducers = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CHARACTER_REQUEST:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
      };
    case actionTypes.PUSH_DATA_VIDEO_STEP_ONE:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
        steps: {
          ...state.steps,
          step_1: {
            ...state.steps.step_1,
            ...action.payload,
          },
        },
      };
    case actionTypes.PUSH_DATA_VIDEO_STEP_TWO:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
        steps: {
          ...state.steps,
          step_2: {
            ...state.steps.step_2,
            ...action.payload,
          },
        },
      };
    case actionTypes.PUSH_DATA_VIDEO_STEP_THREE:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
        steps: {
          ...state.steps,
          step_3: {
            ...state.steps.step_3,
            ...action.payload,
          },
        },
      };
    case actionTypes.PUSH_DATA_VIDEO_STEP_FOUR:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
        steps: {
          ...state.steps,
          step_4: {
            ...state.steps.step_4,
            ...action.payload,
          },
        },
      };
    case actionTypes.VIDEO_PAYMENT_SAVE_REQUEST:
      return {
        isProcessing: true,
        ...state,
      };
    case actionTypes.VIDEO_PAYMENT_SAVE_SUCCESS:
      return {
        isProcessing: false,
        type: '',
        steps: {
          step_1: {},
          step_2: {},
          step_3: {},
          step_4: {
            payment_type: '1pay',
            use_point: 0,
            use_money: PRICE_PAY.ONE,
          },
        },
        resultCreateData: action.payload,
      };
    case actionTypes.VIDEO_PAYMENT_SAVE_FAILED:
      return {
        isProcessing: true,
        ...state,
        resultCreateData: action.payload || [],
      };
    case actionTypes.VIDEO_PAYMENT_CLEAR_STATE:
      return {
        isProcessing: false,
        type: '',
        steps: {
          step_1: {},
          step_2: {},
          step_3: {},
          step_4: {
            payment_type: '1pay',
            use_point: 0,
            use_money: PRICE_PAY.ONE,
          },
        },
        resultCreateData: [],
      };
    case actionTypes.USE_COUPON_FROM_GIFBOX_PAGE:
      return {
        isProcessing: false,
        type: '',
        steps: {
          step_1: {},
          step_2: {},
          step_3: {},
          step_4: {
            payment_type: '1pay',
            use_point: 0,
            use_money: PRICE_PAY.ONE,
            coupon_message_id:action.payload?.id,
            coupon_id:action.payload?.coupon_id,
            coupon_selected:action.payload
          },
        },
      };
    case actionTypes.UPDATE_EXPLAIN_VIDEO_POPUP_REQUEST:
      return {
        ...state,
      };

    case actionTypes.UPDATE_EXPLAIN_VIDEO_POPUP_SUCCESS: 
    return {
      ...state,
    };
    default:
      return state;
  }
};

export default videoReducers;
